import {
  GEOLOCATION_UK,
  GEOLOCATION_DE,
  GEOLOCATION_FR,
  GEOLOCATION_AU,
  EDITION_ID_TO_GEOLOCATION
} from '../constants';

const SUPPORTED_GEOLOCATIONS = [
  GEOLOCATION_UK,
  GEOLOCATION_DE,
  GEOLOCATION_FR,
  GEOLOCATION_AU
];

export const shouldShowGeolocationBanner = (geolocation, editionId) =>
  SUPPORTED_GEOLOCATIONS.includes(geolocation) &&
    geolocation !== EDITION_ID_TO_GEOLOCATION[editionId];
